import {toPennies} from '../utils';

let orderUtils = {
    getSubTotal (line_items=[]) {
        let total = 0;
        line_items.forEach((item) => {
            total = total + toPennies(item.original_price);
        });
        return total;
    },

    getGrandTotal (line_items=[], shipping = 0) {

        let total = 0;

        line_items.forEach((item) => {
            total = total + toPennies(item.sale_price);
        });

        total = total + toPennies(shipping);

        return total;
    },

    padNumber (number) {
        return `**** **** **** ${number}`;
    }
};

export default orderUtils;
